import ProfileLayout from 'components/ProfileLayout';
import EditUserContainer from 'containers/EditUserContainer';
import { inject, observer } from 'mobx-react';
import { ApplicationStoreType } from 'models/ApplicationStore';
import { DataStoreType } from 'models/DataStore';
import React from 'react';
import { HistoryProps, idFromMatch } from 'utils/history';

interface UserEditScreenProps {
  dataStore: DataStoreType;
  applicationStore: ApplicationStoreType;
}

@inject('dataStore', 'applicationStore')
@observer
class UserEditScreen extends React.Component<
  HistoryProps & UserEditScreenProps
> {
  render() {
    const { match, dataStore, applicationStore } = this.props;
    const userId = idFromMatch(match);
    const user = dataStore.users.get(userId!.toString())!;
    const isSelf = applicationStore.currentUser?.id === userId;

    return (
      <ProfileLayout
        active="settings"
        userName={user!.full_name}
        userId={user!.id}
        isSelf={isSelf}
      >
        <EditUserContainer />
      </ProfileLayout>
    );
  }
}

export default (props: any) => {
  // @ts-ignore
  return <UserEditScreen {...props} />;
};
